import { render, staticRenderFns } from "./CatalogosPresentaciones.vue?vue&type=template&id=af3d28ca&"
import script from "./CatalogosPresentaciones.vue?vue&type=script&lang=js&"
export * from "./CatalogosPresentaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports